import React from "react";
import { Link } from "react-router-dom";
import { sanitizeChatUrl } from "@/lib/sanitizeChatUrl";

// Renders chat text containing [label](url) markdown links as real anchor/Link tags.
// Used by both the visitor AI chat widget and the admin live chat dashboard so
// AI responses (which include markdown links) display correctly instead of raw text.
// URL schemes are sanitised: only https/http/mailto/tel and internal "/" paths become
// clickable; javascript:/data:/vbscript:/protocol-relative URLs render as plain text.
export default function ChatMessageContent({ content, linkClassName = "underline font-semibold text-[#A8228B] hover:text-[#8a1c71]" }) {
  const parts = content.split(/(\[([^\]]+)\]\(([^)]+)\))/g);
  const elements = [];
  let i = 0;
  while (i < parts.length) {
    const part = parts[i];
    if (part && part.startsWith("[") && parts[i + 1] && parts[i + 2]) {
      const label = parts[i + 1];
      const rawHref = parts[i + 2];
      const safeHref = sanitizeChatUrl(rawHref);
      if (!safeHref) {
        // Unsafe/unknown scheme — render label as plain text, no anchor
        elements.push(<span key={i}>{label}</span>);
        i += 3;
        continue;
      }
      const isInternal = safeHref.startsWith("/");
      elements.push(
        isInternal ? (
          <Link key={i} to={safeHref} className={linkClassName}>
            {label}
          </Link>
        ) : (
          <a key={i} href={safeHref} target="_blank" rel="noopener noreferrer" className={linkClassName}>
            {label}
          </a>
        )
      );
      i += 3;
    } else if (part && !part.match(/^\[/) && !part.match(/^\(/)) {
      elements.push(<span key={i}>{part}</span>);
      i++;
    } else {
      i++;
    }
  }
  return <>{elements}</>;
}